import React, { useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Table, Chip, img } from "./kit";
import GameCards from "./GameCards";

const n = (v) => Number(v || 0).toLocaleString("tr-TR");

/// leadercc oyun saglayicisi: anahtar, oyun listesi, bizim adreslerimiz.
const LeaderccCard = ({ onSynced }) => {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  useEffect(() => {
    api.config().then((r) => r?.status && setCfg({
      leadercKey: r.config.leadercKey || "",
      leadercListUrl: r.config.leadercListUrl || "",
      leadercIpWhitelist: r.config.leadercIpWhitelist || "",
    }));
  }, []);
  if (!cfg) return null;
  const base = "https://api.badulive.online/game/lc/";
  const save = async () => {
    setBusy(true);
    const r = await api.saveConfig(cfg);
    setBusy(false);
    setMsg(r?.status ? "Kaydedildi." : r?.message || "Kaydedilemedi");
  };
  const sync = async () => {
    setBusy(true);
    await api.saveConfig(cfg);
    const r = await api.leadercSync();
    setBusy(false);
    setMsg(r?.status ? `Liste çekildi: ${r.total} oyun (${r.added} yeni, ${r.updated} güncellendi). Yeni oyunlar iPhone'da kapalı eklenir.` : r?.message || "Liste çekilemedi");
    if (r?.status) onSynced && onSynced();
  };
  const row = (label, v) => (
    <div className="d-flex" style={{ gap: 8, alignItems: "center", marginBottom: 4 }}>
      <span style={{ width: 170, fontSize: 12.5, color: "#64748B" }}>{label}</span>
      <code style={{ fontSize: 12.5, userSelect: "all" }}>{v}</code>
    </div>
  );
  return (
    <div className="card" style={{ marginBottom: 14 }}>
      <div className="card-body">
        <b style={{ fontSize: 16 }}>🎮 leadercc oyunları</b>
        <div style={{ fontSize: 13, color: "#64748B", marginBottom: 10 }}>
          Oyunlar oyun coini ile oynanır. Sesli odada 3/4 pencerede (HD adres), oyun odasında tam ekran açılır.
        </div>
        <div style={{ background: "#F8FAFC", border: "1px solid #E2E8F0", borderRadius: 12, padding: "10px 14px", marginBottom: 12 }}>
          <div style={{ fontSize: 12.5, fontWeight: 700, marginBottom: 6 }}>leadercc'ye verilecek adresler (POST, JSON, MD5 imza)</div>
          {row("1. Kullanıcı bilgisi", base + "user")}
          {row("2. Oyun coini (anlık mod)", base + "coin")}
          {row("3. Sonradan ödeme", base + "supplement")}
        </div>
        <label style={{ fontSize: 12, color: "#6B7280" }}>İmza anahtarı (key) — leadercc ile aynı olmalı</label>
        <input className="form-control" type="password" autoComplete="off" value={cfg.leadercKey} onChange={(e) => setCfg({ ...cfg, leadercKey: e.target.value.trim() })} />
        <label style={{ fontSize: 12, color: "#6B7280", marginTop: 8 }}>Oyun listesi adresi (https, test ya da canlı JSON)</label>
        <input className="form-control" value={cfg.leadercListUrl} placeholder="https://xxx.leadercc.com/games/prod_game_list.json" onChange={(e) => setCfg({ ...cfg, leadercListUrl: e.target.value.trim() })} />
        <label style={{ fontSize: 12, color: "#6B7280", marginTop: 8 }}>IP beyaz listesi (isteğe bağlı, virgülle; boşsa herkes — imza yine şart)</label>
        <input className="form-control" value={cfg.leadercIpWhitelist} onChange={(e) => setCfg({ ...cfg, leadercIpWhitelist: e.target.value })} />
        <div className="d-flex align-items-center" style={{ gap: 8, marginTop: 10, flexWrap: "wrap" }}>
          <button className="btn btn-primary btn-sm" disabled={busy} onClick={save}>Kaydet</button>
          <button className="btn btn-success btn-sm" disabled={busy} onClick={sync}>Oyun listesini çek</button>
          {msg && <span style={{ fontSize: 13, color: "#475569" }}>{msg}</span>}
        </div>
      </div>
    </div>
  );
};

const Games = () => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [draft, setDraft] = useState({});
  const [adding, setAdding] = useState({ key: "", name: "", url: "" });
  const [enabled, setEnabled] = useState(null);
  useEffect(() => {
    api.config().then((r) => r?.status && setEnabled(r.config.gamesEnabled !== false));
  }, []);
  const toggleAll = async () => {
    const next = !enabled;
    if (!next && !window.confirm("Oyun kolu tüm odalardan hemen kaldırılsın mı?")) return;
    const r = await api.saveConfig({ gamesEnabled: next });
    if (r?.status) setEnabled(next);
    else window.alert(r?.message || "Kaydedilemedi");
  };

  const load = async () => {
    const res = await api.games();
    if (res?.status) setGames(res.games);
    setLoading(false);
  };
  useEffect(() => {
    load();
  }, []);

  const save = async (g, patch) => {
    const res = await api.saveGame({ key: g.key, ...patch });
    if (!res?.status) return window.alert(res?.message || "Kaydedilemedi");
    setDraft((d) => ({ ...d, [g.key]: undefined }));
    load();
  };

  const add = async () => {
    const res = await api.saveGame({ ...adding, isActive: true, sort: games.length + 1 });
    if (!res?.status) return window.alert(res?.message || "Eklenemedi");
    setAdding({ key: "", name: "", url: "" });
    load();
  };

  return (
    <>
      <div
        className="card"
        style={{ marginBottom: 14, borderColor: enabled ? "#A7F3D0" : "#FECACA", background: enabled ? "#F0FDF7" : "#FEF2F2" }}
      >
        <div className="card-body d-flex align-items-center justify-content-between" style={{ gap: 12, flexWrap: "wrap" }}>
          <div>
            <b style={{ fontSize: 16 }}>🎮 Oyun kolu {enabled === null ? "…" : enabled ? "AÇIK" : "KAPALI"}</b>
            <div style={{ fontSize: 13, color: "#64748B" }}>
              {enabled ? "Odalarda oyun kolu görünüyor." : "Oyun kolu tüm odalardan kaldırıldı; açık oyunlar da kapanır."}
            </div>
          </div>
          <button
            className={`btn ${enabled ? "btn-danger" : "btn-success"}`}
            style={{ minWidth: 180, minHeight: 46, fontSize: 16, fontWeight: 700 }}
            onClick={toggleAll}
            disabled={enabled === null}
          >
            {enabled ? "Oyun kolunu kapat" : "Oyun kolunu aç"}
          </button>
        </div>
      </div>
      <GameCards games={games} reload={load} />
      <details style={{ marginBottom: 14 }}>
        <summary style={{ cursor: "pointer", fontWeight: 700, minHeight: 44, display: "flex", alignItems: "center" }}>🎮 Leadercc sağlayıcısı (ileride kullanılacak)</summary>
        <LeaderccCard onSynced={load} />
      </details>
      <details>
      <summary style={{ cursor: "pointer", fontWeight: 700, minHeight: 44, display: "flex", alignItems: "center", marginBottom: 8 }}>🛠️ Oyun kayıtları: adres, ikon, platform, ülke (gelişmiş)</summary>
      <PageHead
        title="Oyunlar"
        sub="Odalarda menüde çıkan oyunlar. Açık/Kapalı ile anında yayından kaldırılır. iOS ayrıca açılmadıkça iPhone'da görünmez. Ülke boşsa her yerde, doluysa sadece yazılan ülkelerde (TR, AE…) görünür."
      />
      <datalist id="oyun-kategorileri">
        {[...new Set(games.map((x) => x.category).filter(Boolean)), "Çark", "Slot", "Kart", "Balık", "Hızlı"].filter((v, i, a) => a.indexOf(v) === i).map((c) => <option key={c} value={c} />)}
      </datalist>
      <Table
        loading={loading}
        head={["Sıra", "İkon", "Oyun", "Adresler (https)", "Platform, ülke, kategori", "Durum", ""]}
        rows={games.map((g) => {
          const d = draft[g.key] || {};
          return (
            <tr key={g.key}>
              <td style={{ width: 70 }}>
                <input className="form-control form-control-sm" type="number" defaultValue={g.sort} onBlur={(e) => Number(e.target.value) !== g.sort && save(g, { sort: e.target.value })} />
              </td>
              <td style={{ width: 76 }}>
                <label style={{ cursor: "pointer", margin: 0 }} title="Oyun ikonu yükle (kare)">
                  {g.image ? (
                    <img src={img(g.image)} alt="" style={{ width: 56, height: 56, borderRadius: 12, objectFit: "cover" }} />
                  ) : (
                    <div style={{ width: 56, height: 56, borderRadius: 12, border: "1px dashed #CBD5E1", display: "grid", placeItems: "center", fontSize: 11, color: "#64748B" }}>
                      İkon
                    </div>
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={async (e) => {
                      const f = e.target.files?.[0];
                      if (!f) return;
                      const fd = new FormData();
                      fd.append("image", f);
                      const r = await api.gameImage(g.key, fd);
                      if (!r?.status) window.alert(r?.message || "Yüklenemedi");
                      load();
                    }}
                  />
                </label>
              </td>
              <td style={{ minWidth: 170 }}>
                <input className="form-control form-control-sm" value={d.name ?? g.name} onChange={(e) => setDraft({ ...draft, [g.key]: { ...d, name: e.target.value } })} />
                <div style={{ fontSize: 11, color: "#6B7280", marginTop: 3 }}>
                  <code>{g.key}</code>
                  {g.providerGameId ? ` · ID ${g.providerGameId}` : ""}
                </div>
              </td>
              <td style={{ minWidth: 300 }}>
                <input className="form-control form-control-sm" placeholder="Tam ekran https://..." value={d.url ?? g.url} onChange={(e) => setDraft({ ...draft, [g.key]: { ...d, url: e.target.value } })} />
                <input className="form-control form-control-sm" style={{ marginTop: 4 }} placeholder="HD yarım ekran https://... (isteğe bağlı)" value={d.halfUrl ?? g.halfUrl ?? ""} onChange={(e) => setDraft({ ...draft, [g.key]: { ...d, halfUrl: e.target.value } })} />
              </td>
              <td style={{ minWidth: 170 }}>
                <div className="d-flex" style={{ gap: 4 }}>
                  <button className={`btn btn-sm ${g.android !== false ? "btn-success" : "btn-outline-secondary"}`} onClick={() => save(g, { android: g.android === false })}>
                    Android
                  </button>
                  <button className={`btn btn-sm ${g.ios ? "btn-success" : "btn-outline-secondary"}`} onClick={() => save(g, { ios: !g.ios })}>
                    iOS
                  </button>
                </div>
                <input
                  className="form-control form-control-sm"
                  style={{ marginTop: 4 }}
                  placeholder="Tüm ülkeler (ör. AE,SA)"
                  value={d.countries ?? (g.countries || []).join(",")}
                  onChange={(e) => setDraft({ ...draft, [g.key]: { ...d, countries: e.target.value } })}
                />
                {/* oyun merkezi: kategori cipi ve kart etiketi */}
                <input
                  className="form-control form-control-sm"
                  style={{ marginTop: 4 }}
                  placeholder="Kategori (ör. Çark, Slot, Kart)"
                  list="oyun-kategorileri"
                  value={d.category ?? g.category ?? ""}
                  onChange={(e) => setDraft({ ...draft, [g.key]: { ...d, category: e.target.value } })}
                />
                <select className="form-control form-control-sm" style={{ marginTop: 4 }} value={g.badge || ""} onChange={(e) => save(g, { badge: e.target.value })}>
                  <option value="">Etiket yok</option>
                  <option value="hot">HOT</option>
                  <option value="new">YENİ</option>
                </select>
              </td>
              <td>
                <button className={`btn btn-sm ${g.isActive ? "btn-outline-success" : "btn-outline-secondary"}`} onClick={() => save(g, { isActive: !g.isActive })}>
                  {g.isActive ? "Açık" : "Kapalı"}
                </button>{" "}
                {g.url ? <Chip>Bağlı</Chip> : <Chip kind="wait">Yakında</Chip>}
              </td>
              <td style={{ whiteSpace: "nowrap" }}>
                <button className="btn btn-sm btn-primary" disabled={!draft[g.key]} onClick={() => save(g, d)}>
                  Kaydet
                </button>{" "}
                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={async () => {
                    if (!window.confirm(`${g.name} silinsin mi?`)) return;
                    await api.deleteGame(g.key);
                    load();
                  }}
                >
                  Sil
                </button>
              </td>
            </tr>
          );
        })}
      />
      <div className="card">
        <div className="card-body">
          <h6>Yeni oyun ekle</h6>
          <div className="d-flex" style={{ gap: 8, flexWrap: "wrap" }}>
            <input className="form-control" style={{ maxWidth: 160 }} placeholder="anahtar (ör. tavla)" value={adding.key} onChange={(e) => setAdding({ ...adding, key: e.target.value.toLowerCase() })} />
            <input className="form-control" style={{ maxWidth: 200 }} placeholder="Görünen ad" value={adding.name} onChange={(e) => setAdding({ ...adding, name: e.target.value })} />
            <input className="form-control" style={{ flex: 1, minWidth: 240 }} placeholder="https://oyun-saglayici.com/..." value={adding.url} onChange={(e) => setAdding({ ...adding, url: e.target.value })} />
            <button className="btn btn-primary" disabled={!adding.key || !adding.name} onClick={add}>
              Ekle
            </button>
          </div>
        </div>
      </div>
      </details>
    </>
  );
};

export default Games;
